import type { LabelCheckValue } from '@ulysses-inc/harami_api_client'
import { Space } from 'antd'
import { useContext } from 'react'
import { Text } from 'src/components/nativeCompat/Text'
import { LabelCheckAnswerStoreContext } from 'src/features/labelCheck/contexts/LabelCheckAnswerStoreContext'
import { LabelResultSection } from './LabelResultSection'

type Props = {
  labelCheckValue: LabelCheckValue
}

export const LabelCheckAnswer = ({ labelCheckValue }: Props) => {
  const { reportLabelInspectionId: labelInspectionResultId } = labelCheckValue

  const { labelInspectionResultMap } = useContext(LabelCheckAnswerStoreContext)

  const labelInspectionResult = labelInspectionResultMap.get(
    labelInspectionResultId,
  )

  if (!labelInspectionResult) {
    return <></>
  }

  return (
    <Space direction="vertical" size="middle">
      <Text>{labelInspectionResult.name}</Text>
      <Space direction="vertical" size="middle">
        {labelInspectionResult.reportLabels.map(labelResult => (
          <LabelResultSection
            key={labelResult.labelId}
            labelResult={labelResult}
          />
        ))}
      </Space>
    </Space>
  )
}
